import type { RootState } from 'src/redux/store'

export const selectTermsAndConditions = (state: RootState): string =>
  state['@agreements'].termsAndConditions.data

export const selectPrivacyPolicy = (state: RootState): string =>
  state['@agreements'].privacyPolicy.data
